import { defineComponent, onMounted } from "vue";

export default defineComponent({
  props: {
    buttonlabel: { type: String, required: true },
    backgroundColor: { type: String, required: false },
  },
  setup() {
    onMounted(() => {
      window.cfields = [];
      window._load_script = function (url, callback) {
        var head = document.querySelector("head"),
          script = document.createElement("script"),
          r = false;

        script.type = "text/javascript";
        script.charset = "utf-8";
        script.src = url;

        if (callback) {
          script.onload = script.onreadystatechange = function () {
            if (!r && (!this.readyState || this.readyState === "complete")) {
              r = true;
              callback();
            }
          };
        }

        head.appendChild(script);
      };
      window._show_thank_you = function (id, message, trackcmpUrl, email) {
        var form = document.getElementById("_form_" + id + "_"),
          thankYou = form.querySelector("._form-thank-you");

        form.querySelector("._form-content").style.display = "none";
        thankYou.innerHTML = message;
        thankYou.style.display = "block";

        const vgoAlias = "vgo";

        var visitorObject = window[vgoAlias];

        if (email && typeof visitorObject !== "undefined") {
          visitorObject("setEmail", email);
          visitorObject("update");
        } else if (typeof trackcmpUrl !== "undefined" && trackcmpUrl) {
          // Site tracking URL to use after inline form submission.
          window._load_script(trackcmpUrl);
        }

        if (typeof window._form_callback !== "undefined")
          window._form_callback(id);
      };
      window._show_error = function (id, message, html) {
        var form = document.getElementById("_form_" + id + "_"),
          err = document.createElement("div"),
          button = form.querySelector("button"),
          oldError = form.querySelector("._form_error");

        if (oldError) oldError.parentNode.removeChild(oldError);

        err.innerHTML = message;
        err.className = "_error-inner _form_error _no_arrow";

        var wrapper = document.createElement("div");

        wrapper.className = "_form-inner";
        wrapper.appendChild(err);
        button.parentNode.insertBefore(wrapper, button);
        document.querySelector('[id^="_form"][id$="_submit"]').disabled = false;

        if (html) {
          var div = document.createElement("div");

          div.className = "_error-html";
          div.innerHTML = html;
          err.appendChild(div);
        }
      };

      function initNewsletterScript(formToSubmit) {
        if (window.location.search.search("excludeform") !== -1) return false;

        //eslint-disable-next-line
        var getCookie = function (name) {
          var match = document.cookie.match(
            new RegExp("(^|; )" + name + "=([^;]+)")
          );

          return match ? match[2] : null;
        };

        //eslint-disable-next-line
        var setCookie = function (name, value) {
          var now = new Date();
          var time = now.getTime();
          var expireTime = time + 1000 * 60 * 60 * 24 * 365;

          now.setTime(expireTime);
          document.cookie = name + "=" + value + "; expires=" + now + ";path=/";
        };
        var addEvent = function (element, event, func) {
          if (element.addEventListener) {
            element.addEventListener(event, func);
          } else {
            var oldFunc = element["on" + event];

            element["on" + event] = function () {
              oldFunc.apply(this, arguments);
              func.apply(this, arguments);
            };
          }
        };
        var removed = false;
        var allInputs = formToSubmit.querySelectorAll(
            "input, select, textarea"
          ),
          tooltips = [],
          submitted = false;

        var getUrlParam = function (name) {
          var regexStr = "[?&]" + name + "=([^&#]*)";
          var results = new RegExp(regexStr, "i").exec(window.location.href);

          return results !== undefined && results !== null
            ? decodeURIComponent(results[1])
            : false;
        };

        for (var i = 0; i < allInputs.length; i++) {
          var regexStr = "field\\[(\\d+)\\]";
          var results = new RegExp(regexStr).exec(allInputs[i].name);

          if (results !== undefined && results !== null) {
            allInputs[i].dataset.name = window.cfields[results[1]];
          } else {
            allInputs[i].dataset.name = allInputs[i].name;
          }

          var fieldVal = getUrlParam(allInputs[i].dataset.name);

          if (fieldVal) {
            if (allInputs[i].dataset.autofill === "false") {
              continue;
            }

            if (
              allInputs[i].type === "radio" ||
              allInputs[i].type === "checkbox"
            ) {
              if (allInputs[i].value === fieldVal) {
                allInputs[i].checked = true;
              }
            } else {
              allInputs[i].value = fieldVal;
            }
          }
        }

        var removeTooltips = function () {
          for (var i = 0; i < tooltips.length; i++) {
            tooltips[i].tip.parentNode.removeChild(tooltips[i].tip);
          }

          tooltips = [];
        };
        var removeTooltip = function (elem) {
          for (var i = 0; i < tooltips.length; i++) {
            if (tooltips[i].elem === elem) {
              tooltips[i].tip.parentNode.removeChild(tooltips[i].tip);
              tooltips.splice(i, 1);

              return;
            }
          }
        };
        var createTooltip = function (elem, text) {
          var tooltip = document.createElement("div"),
            arrow = document.createElement("div"),
            inner = document.createElement("div"),
            newTooltip = {};

          if (elem.type !== "radio" && elem.type !== "checkbox") {
            tooltip.className = "_error";
            arrow.className = "_error-arrow";
            inner.className = "_error-inner";
            inner.innerHTML = text;
            tooltip.appendChild(arrow);
            tooltip.appendChild(inner);
            elem.parentNode.appendChild(tooltip);
          } else {
            tooltip.className = "_error-inner _no_arrow";
            tooltip.innerHTML = text;
            elem.parentNode.insertBefore(tooltip, elem);
            newTooltip.no_arrow = true;
          }

          newTooltip.tip = tooltip;
          newTooltip.elem = elem;
          tooltips.push(newTooltip);

          return newTooltip;
        };
        var resizeTooltip = function (tooltip) {
          var rect = tooltip.elem.getBoundingClientRect();
          var doc = document.documentElement,
            scrollPosition =
              rect.top -
              ((window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0));

          if (scrollPosition < 40) {
            tooltip.tip.className =
              tooltip.tip.className.replace(/ ?(_above|_below) ?/g, "") +
              " _below";
          } else {
            tooltip.tip.className =
              tooltip.tip.className.replace(/ ?(_above|_below) ?/g, "") +
              " _above";
          }
        };
        var resizeTooltips = function () {
          if (removed) return;

          for (var i = 0; i < tooltips.length; i++) {
            if (!tooltips[i].no_arrow) resizeTooltip(tooltips[i]);
          }
        };

        var validateField = function (elem, remove) {
          var tooltip = null,
            value = elem.value,
            noError = true;

          if (remove) {
            removeTooltip(elem);
          }

          if (elem.type !== "checkbox")
            elem.className = elem.className.replace(/ ?_has_error ?/g, "");

          if (elem.getAttribute("required") !== null) {
            if (
              elem.type === "radio" ||
              (elem.type === "checkbox" && /any/.test(elem.className))
            ) {
              var elems = formToSubmit.elements[elem.name];

              if (
                !(
                  elems instanceof NodeList || elems instanceof HTMLCollection
                ) ||
                elems.length <= 1
              ) {
                noError = elem.checked;
              } else {
                noError = false;

                for (var i = 0; i < elems.length; i++) {
                  if (elems[i].checked) noError = true;
                }
              }

              if (!noError) {
                tooltip = createTooltip(elem, "Maak a.u.b. een keuze");
              }
            } else if (elem.type === "checkbox") {
              var elems2 = formToSubmit.elements[elem.name],
                found = false,
                err = [];

              noError = true;

              for (var j = 0; j < elems2.length; j++) {
                if (elems2[j].getAttribute("required") === null) continue;

                if (!found && elems2[j] !== elem) return true;

                found = true;
                elems2[j].className = elems2[j].className.replace(
                  / ?_has_error ?/g,
                  ""
                );

                if (!elems2[j].checked) {
                  noError = false;
                  elems2[j].className = elems2[j].className + " _has_error";
                  err.push(
                    "Afvinken van %s is vereist".replace("%s", elems2[j].value)
                  );
                }
              }

              if (!noError) {
                tooltip = createTooltip(elem, err.join("<br/>"));
              }
            } else if (elem.tagName === "SELECT") {
              var selected = true;

              if (elem.multiple) {
                selected = false;

                for (var k = 0; k < elem.options.length; k++) {
                  if (elem.options[k].selected) {
                    selected = true;
                    break;
                  }
                }
              } else {
                for (var l = 0; l < elem.options.length; l++) {
                  if (elem.options[l].selected && !elem.options[l].value) {
                    selected = false;
                  }
                }
              }

              if (!selected) {
                elem.className = elem.className + " _has_error";
                noError = false;
                tooltip = createTooltip(elem, "Maak a.u.b. een keuze");
              }
            } else if (value === undefined || value === null || value === "") {
              elem.className = elem.className + " _has_error";
              noError = false;
              tooltip = createTooltip(elem, "Dit veld is verplicht.");
            }
          }

          if (noError && elem.name === "email") {
            if (
              !value.match(
                /^[\+_a-z0-9-'&=]+(\.[\+_a-z0-9-']+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i //eslint-disable-line
              )
            ) {
              elem.className = elem.className + " _has_error";
              noError = false;
              tooltip = createTooltip(elem, "Voer een geldig e-mailadres in.");
            }
          }

          if (noError && /date_field/.test(elem.className)) {
            if (!value.match(/^\d\d\d\d-\d\d-\d\d$/)) {
              elem.className = elem.className + " _has_error";
              noError = false;
              tooltip = createTooltip(elem, "Voer een geldige datum in.");
            }
          }

          if (tooltip) {
            resizeTooltip(tooltip);
          }

          return noError;
        };
        var needsValidate = function (el) {
          if (el.getAttribute("required") !== null) {
            return true;
          }

          if (el.name === "email" && el.value !== "") {
            return true;
          }

          return false;
        };
        var validateForm = function (e) {
          //eslint-disable-next-line
          var err = formToSubmit.querySelector("._form_error"),
            noError = true;

          if (!submitted) {
            submitted = true;

            for (var i = 0, len = allInputs.length; i < len; i++) {
              var input = allInputs[i];

              if (needsValidate(input)) {
                if (input.type === "text") {
                  addEvent(input, "blur", function () {
                    this.value = this.value.trim();
                    validateField(this, true);
                  });
                  addEvent(input, "input", function () {
                    validateField(this, true);
                  });
                } else if (
                  input.type === "radio" ||
                  input.type === "checkbox"
                ) {
                  (function (el) {
                    var radios = formToSubmit.elements[el.name];

                    for (var i = 0; i < radios.length; i++) {
                      addEvent(radios[i], "click", function () {
                        validateField(el, true);
                      });
                    }
                  })(input);
                } else if (input.tagName === "SELECT") {
                  addEvent(input, "change", function () {
                    validateField(this, true);
                  });
                } else if (input.type === "textarea") {
                  addEvent(input, "input", function () {
                    validateField(this, true);
                  });
                }
              }
            }
          }

          removeTooltips();

          for (var m = 0, length = allInputs.length; m < length; m++) {
            var elem = allInputs[m];

            if (needsValidate(elem)) {
              if (elem.tagName.toLowerCase() !== "select") {
                elem.value = elem.value.trim();
              }

              if (!validateField(elem)) {
                noError = false;
              }
            }
          }

          if (!noError && e) {
            e.preventDefault();
          }

          resizeTooltips();

          return noError;
        };

        addEvent(window, "resize", resizeTooltips);
        addEvent(window, "scroll", resizeTooltips);
        window._old_serialize = null;

        if (typeof serialize !== "undefined")
          window._old_serialize = window.serialize;

        window._load_script(
          "//d3rxaij56vjege.cloudfront.net/form-serialize/0.3/serialize.min.js",
          function () {
            window._form_serialize = window.serialize;

            if (window._old_serialize) window.serialize = window._old_serialize;
          }
        );

        const formSubmit = function (e) {
          e.preventDefault();

          if (validateForm()) {
            // use this trick to get the submit button & disable it using plain javascript
            document.querySelector("#_form_2_submit").disabled = true;

            var serialized = window._form_serialize(
              document.getElementById("_form_2_")
            );
            var err = formToSubmit.querySelector("._form_error");

            if (err) {
              err.parentNode.removeChild(err);
            }

            window._load_script(
              "https://nederlandsmijnmuseum.activehosted.com/proc.php?" +
                serialized +
                "&jsonp=true"
            );
          }

          return false;
        };

        addEvent(formToSubmit, "submit", formSubmit);
      }

      var formToSubmit = document.getElementById("_form_2_");

      initNewsletterScript(formToSubmit);
    });

    const submitForm = (e) => {
      e.preventDefault();
      document.querySelector("#_form_2_submit").click();
    };

    return { submitForm };
  },
});
